const BLANK_TEXT = /^\s*$/;

export const isBlankInline = (node) => {
  if (node.type.name === "hardBreak") return true;
  return node.isText && BLANK_TEXT.test(node.text || "");
};

export const isSpacerParagraph = (node) => {
  if (node.type.name !== "paragraph") return false;
  if (node.childCount === 0) return true;
  for (let i = 0; i < node.childCount; i += 1) {
    if (!isBlankInline(node.child(i))) return false;
  }
  return true;
};
